import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { AppConfigurationProvider } from '@app-core/models/config';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable()
export class RedirectInterceptor implements HttpInterceptor {
  constructor(private _injector: Injector) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((response: HttpResponse<any>) => {
        if (response.status !== 503) return throwError(response);

        const config = this._injector.get(AppConfigurationProvider);

        window.location.href = config.redirect_url
          ? config.redirect_url
          : 'https://www.ns.nl';
      })
    );
  }
}
